import exampleData from './../data/example.json';
import { ENDPOINTS } from './ApiConstants';

const DEBUG = true;

export async function localFetch({ endpoint, fetchUrl, fetchParameters }) {
    if (DEBUG) console.log(`localFetch :: ${fetchParameters.method} :: ${fetchUrl}`);
    switch (endpoint) {
        case ENDPOINTS.exampleGet:
            await new Promise(resolve => {
                setTimeout(resolve, 2000)
            });

            return new Response(JSON.stringify(exampleData.get), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });
        case ENDPOINTS.examplePost:
            await new Promise(resolve => setTimeout(resolve, 2000));

            return new Response(JSON.stringify(exampleData.post), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });
        case ENDPOINTS.getConfiguration:
            await new Promise(resolve => setTimeout(resolve, 2000));

            return new Response(JSON.stringify(exampleData.configuration), {
                status: 200,
                headers: { "Content-Type": "application/json" }
            });
        default:
            throw new Error(`localFetch :: Unknown endpoint: ${endpoint}`);
    }
}